'use client'

import { createContext, type PropsWithChildren, useEffect, useRef } from 'react'
import type { LandingPageId } from '@/shared/config/site'
import { LandingPageViewmodel } from './landing-page.viewmodel'

export const LandingPageViewmodelContext = createContext<LandingPageViewmodel | null>(null)

type LandingPageProviderProps = PropsWithChildren<{
  pageId: LandingPageId
}>

export function LandingPageProvider({ children, pageId }: LandingPageProviderProps) {
  const landingPageViewmodelRef = useRef<LandingPageViewmodel | null>(null)

  if (!landingPageViewmodelRef.current || landingPageViewmodelRef.current.page.id !== pageId) {
    landingPageViewmodelRef.current = new LandingPageViewmodel(pageId)
  }

  const documentTitle = landingPageViewmodelRef.current.page.content.documentTitle

  useEffect(() => {
    const landingPageViewmodel = landingPageViewmodelRef.current!

    landingPageViewmodel.init()

    return () => landingPageViewmodel.dispose()
  }, [])

  useEffect(() => {
    landingPageViewmodelRef.current?.syncDocumentTitle(documentTitle)
  }, [documentTitle])

  return (
    <LandingPageViewmodelContext.Provider value={landingPageViewmodelRef.current}>
      {children}
    </LandingPageViewmodelContext.Provider>
  )
}
